import { useLayoutContext } from '../../../Context/Layout.context';
import { createPdf } from '../../../services/supportPdf/supportPdf.service';
import { PdfEditor } from '../PdfEditor/PdfEditor.component';
import { addPdf } from '../../../const/addSupportPdf';

interface PdfAddProps {
  onClose: () => void;
  onChange: () => void;
}

export const PdfAdd: React.FC<PdfAddProps> = ({ onClose, onChange }) => {
  const handleClose = () => {
    onClose();
  };

  const { openAlert } = useLayoutContext();

  const handleSave = (title: string, file: File) => {
    createPdf(title, file).then(
      () => {
        openAlert('success');
        onClose();
        onChange();
      },
      () => {
        openAlert('save_error');
      },
    );
  };
  return (
    <PdfEditor
      title={addPdf + ' instrukcję'}
      onCancel={handleClose}
      onSave={handleSave}
      onChange={onChange}
      titlePdf={''}
      sizePdf={''}
      pdfId={''}
      file={''}
      path={''}
      fileName={''}
    />
  );
};
